import { useEffect } from 'react';
import { useUserGroupAvailableUsers } from '../../hooks/useUserGroupAvailableUsers';

function SearchUsers (props) {
    const handleSearchResult = props.handleSearchResult;
    const name = props.name;
    const userGroupId = props.userGroupId;

    const {
      isLoading,
      error,
      data,
    } = useUserGroupAvailableUsers(userGroupId, name);

    useEffect(() => {
      if (data) {
        handleSearchResult(data);
      }
    }, [data, handleSearchResult]);

    if (isLoading) return 'Loading...';
    if (error) return `Error! ${error.message}`;
    return null;
}

export default SearchUsers
